import React, { Component } from 'react';
import styled from 'styled-components';
import { COLORS, FONT_FACE } from '../constants/theme';
import { ContainerStyles } from './styles/Container';
import { Button } from './styles/Button';
import Loader from './styles/Loader';
import moment from 'moment';

const ReviewStyles = styled.div`
  box-sizing: border-box;
  padding: 15px 30px;
  background-color: ${COLORS.WHITE};
  break-inside: avoid;
  page-break-inside: avoid;
  width: 100%;
  display: block;
  color: ${props => props.theme.COLORS.GREY.platinumDark};

  .meta {
    font-family: ${FONT_FACE.BOOK};
    font-size: 1rem;
    display: flex;
    justify-content: space-between;

    span {
      text-transform: uppercase;
    }
  }

  header {
    border-top: 2px solid ${props => props.theme.COLORS.GREY.platinumDark};
    border-bottom: 2px solid ${props => props.theme.COLORS.GREY.platinumDark};
    padding: 15px 0;
    display: flex;

    h2 {
      text-transform: uppercase;
      margin: 0;
      font-family: ${FONT_FACE.LIGHT};
      font-size: 1.5rem;
      line-height: 26px;
    }
    .rate {
      text-align: center;
      font-family: ${FONT_FACE.BOLD};
      margin-right: 10px;

      svg {
        vertical-align: inherit;
        transform: translateY(-2px);
      }
    }
  }

  p {
    font-family: ${FONT_FACE.LIGHT};
    font-size: 1.6rem;
    line-height: 26px;
    margin-top: 1rem;
  }
`;

const LayoutStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;
  row-gap: 3rem;

  @media (max-width: ${props => props.brakepoint}px) {
    grid-template-columns: 1fr;

    > div {
      max-width: 580px;
      margin: 0 auto;
    }
  }
`;

const ShowMoreButton = ({ children, disabled, onClick }) => {
  return (
    <Button className="button button--primary" disabled={disabled} onClick={onClick}>
      <span className="button__text">{children}</span>
      <span className="icon button__icon">
        <svg viewBox="0 0 20 6">
          <path d="M17.0303 0.469727C16.7373 0.176758 16.2627 0.176758 15.9697 0.469727C15.6768 0.762695 15.6768 1.2373 15.9697 1.53027L16.6895 2.25H1.5C1.08594 2.25 0.75 2.58594 0.75 3C0.75 3.41406 1.08594 3.75 1.5 3.75H16.6895L15.9697 4.46973C15.6768 4.7627 15.6768 5.2373 15.9697 5.53027C16.1162 5.67676 16.3081 5.75 16.5 5.75C16.6919 5.75 16.8838 5.67676 17.0303 5.53027L19.5605 3L17.0303 0.469727Z"></path>
        </svg>
      </span>
    </Button>
  );
};

const ReviewsStyles = styled.div`
  background-color: ${props => props.theme.COLORS.GREY.mist};
`;

const StarRating = ({ rate = 5, maxRate = 5, size = 16 }) => (
  <svg width={maxRate * size} height={size}>
    <defs>
      <pattern id="starPattern" x="0" y="0" width={size} height={size} patternUnits="userSpaceOnUse">
        <path
          className="st0"
          d="M12.25,15.05L7.8,12.71l-4.45,2.34l0.85-4.95l-3.6-3.51l4.97-0.72L7.8,1.36l2.22,4.51L15,6.59l-3.6,3.51 L12.25,15.05z M7.8,11.41l2.93,1.54l-0.56-3.26l2.37-2.31L9.27,6.91L7.8,3.94L6.34,6.91L3.07,7.39l2.37,2.31l-0.56,3.26L7.8,11.41z"
        />
      </pattern>
    </defs>
    <rect x="0" y="0" width={rate * size} height={size} fill="url(#starPattern)" />
  </svg>
);

const Review = ({ customerName, openAnswer, rating, reviewDate, starRating, type }) => {
  if (starRating > 5) {
    starRating = starRating / 10;
  }
  const [name, place] = customerName.split(' (');
  return (
    <ReviewStyles>
      <div className="meta">
        <span>{moment(reviewDate).format('DD-MM-YYYY')}</span>
        <span>{type}</span>
      </div>
      <header>
        <div className="rate" title={starRating}>
          <StarRating rate={starRating} />
        </div>
        <h2>
          {name} {!!place && <br />}
          {!!place && `(${place}`}
        </h2>
      </header>
      <p>{openAnswer}</p>
    </ReviewStyles>
  );
};

const Layout = props => (
  <LayoutStyles cardsLength={props.reviews.length} brakepoint={props.brakepoint}>
    {props.reviews.map((review, index) => (
      <Review key={index} {...review} />
    ))}
  </LayoutStyles>
);

class Reviews extends Component {
  state = {
    columns: 2,
    brakepoint: 900,
  };

  updateDimensions = () => {
    let winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const columns = winWidth <= this.state.brakepoint ? 1 : 2;
    if (this.state.columns !== columns) {
      this.setState({ columns });
    }
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { columns, brakepoint } = this.state;
    const { reviews: reviewsOg, amount, showMore, total, fetching, fetched, error } = this.props;
    const reviews = reviewsOg.slice(0, amount);
    return (
      <ReviewsStyles>
        <ContainerStyles style={{ paddingTop: 30, paddingBottom: 30 }}>
          {reviews && <Layout columns={columns} reviews={reviews} brakepoint={brakepoint} />}
          {fetching && (
            <div style={{ margin: '0 auto', width: 64 }}>
              <Loader />
            </div>
          )}
          {fetched && (
            <ShowMoreButton disabled={amount >= total} onClick={showMore}>
              Bekijk meer
            </ShowMoreButton>
          )}
          {error && (
            <div>
              Helaas hebben wij geen reviews kunnen ophalen, probeer het later nog eens. Excuses voor het ongemak!
            </div>
          )}
        </ContainerStyles>
      </ReviewsStyles>
    );
  }
}

export default Reviews;
